import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { actionTypes, maxFileSize } from '../../constants';
import i18next from "../../i18n";
import { downloadFile } from '../document/DocumentHelpers';
import { dispatcherActionTypes, globalEventDispatcher } from '../helpers/GlobalEventDispatcher';
import { getBase64 } from '../helpers/HelperFunctions';
import { hideModalDialog, showModalDialog } from '../ModalDialog';
import { Svg } from '../Svg';
import { Table } from '../table/Table';
import { PdfViewer } from '../PdfViewer';
import * as CheckFunctions from '../helpers/CheckFunctions';

const columnsSettings = [
    {
        "id": "0",
        "name": "Id",
        "headerName": "",
        "type": "string",
        "hidden": true
    },
    {
        "id": "1",
        "name": "FileName",
        "CanSort": true,
        "headerName": i18next.t("documentName"),
        "type": "string"
    },
    {
        "id": "2",
        "name": "CreatorFullName",
        "CanSort": true,
        "headerName": i18next.t("author"),
        "type": "string"
    },
    {
        "id": "3",
        "name": "Created",
        "headerName": i18next.t("dateAddition"),
        "CanSort": true,
        "type": "date"
    }
]
export class FilesAttachmentsForm extends Component {
    static propTypes = {
        name: PropTypes.string,
        attachments: PropTypes.array,
        actions: PropTypes.array,
        edite: PropTypes.bool,
        changedCallback: PropTypes.func
    };
    constructor(props) {
        super(props);
        this.state = {
            attachments: this.props.attachments,
            statuses: [],
            columns: this.props.columns && this.props.columns.length > 0 ? this.props.columns : columnsSettings
        };
        this.actionHandlerCallback = this.actionHandlerCallback.bind(this);
        this.deleteAttachments = this.deleteAttachments.bind(this);
        this.loadFilePreview = this.loadFilePreview.bind(this);
        this.downloadFiles = this.downloadFiles.bind(this);
        this.changeFile = this.changeFile.bind(this);
    }
    componentDidUpdate() {
        if (this.props.attachments !== this.state.attachments) {
            this.setState({ attachments: this.props.attachments });
        }
    }
    deleteAttachments(ids) {
        let { attachments } = this.state;
        attachments = attachments.filter(a => !ids.includes(a.id));
        this.setState({ attachments: attachments });
        globalEventDispatcher.dispatch(dispatcherActionTypes.onUnselectTableAllRows);
        if (this.props.changedCallback)
            this.props.changedCallback(attachments);
    }
    async downloadFiles(ids) {
        if (this.state.attachments && ids && ids.length > 0) {
            for (let i = 0; i < ids.length; i++) {
                let current = this.state.attachments.find(it => it.id === ids[i]);
                if (current) {
                    if (current.content?.content) {
                        let anchor = document.createElement("a");
                        anchor.href = `data:${current.content.mimeType};base64,` + current.content?.content;
                        anchor.download = current.title;
                        anchor.click();
                    }
                    else if (current?.nodeRef) {
                        downloadFile(current?.nodeRef);
                    }
                    else {
                        let objectUrl = window.URL.createObjectURL(current.file);
                        let anchor = document.createElement("a");
                        anchor.href = objectUrl;
                        anchor.download = current.file.name;
                        anchor.click();
                        window.URL.revokeObjectURL(objectUrl);
                    }
                }
            }
        }
    }
    changeFile(e) {
        e.persist();
        let targetId = e.target.getAttribute('target-id');
        if (e.target.files && e.target.files.length > 0 && targetId) {
            let errorMessage = CheckFunctions.getFileAttachmentErrorMessage(e.target.files[0], this.props.allowedExtensions, maxFileSize);
            if (errorMessage) {
                showModalDialog("modalDialog", i18next.t("message"), "", <div className="info-message">{errorMessage}</div>, "feedPopup", true, [{ title: i18next.t("ok"), clickHandler: () => hideModalDialog("modalDialog"), class: "btn-primary" }]);
                e.target.value = null;
            }
            else {
                let fileName = e.target.files[0]?.name;
                if (fileName) {
                    let { attachments } = this.state;
                    var index = attachments.findIndex(a => a.id === targetId);
                    if (index < 0)
                        return;

                    const file = e.target.files[0];
                    let newAttachment = { id: (new Date().getTime()).toString(), file: file, fileName: fileName };
                    attachments[index] = newAttachment;
                    
                    this.setState({ attachments: attachments });
                    globalEventDispatcher.dispatch(dispatcherActionTypes.onUnselectTableAllRows);
                    if (this.props.changedCallback)
                        this.props.changedCallback(attachments);
                }
                e.target.value = null;
            }
        }
    }
    async loadFilePreview(id) {
        const finded = this.state.attachments.filter(a => a.id === id);
        if (finded.length <= 0)
            return;
        const current = finded[0];
        const isImage = CheckFunctions.isImageFile(current.fileName);
        if (!current.fileName.toLowerCase().endsWith('.pdf') && !isImage) {
            this.downloadFiles([id]);
            hideModalDialog("loadingDialog");
            return;
        }
        const currentObject = this;
        let base64;
        if (current?.content?.content) {
            base64 = `data:${current.content.mimeType};base64,` + current?.content?.content;
        }
        else if (current?.nodeRef) {
            if (isImage) {
                import('../ModalDialogsTemplates').then(templates => { templates.viewImageDialog(current.nodeRef) });
            }
            else {
                import('../ModalDialogsTemplates').then(templates => { templates.viewPdfDialog(current.nodeRef) });
            }
        }
        else {
            base64 = (await getBase64(current.file, true)).content;
        }
        if (base64) {
            if (isImage) {
                import('../ModalDialogsTemplates').then(templates => { templates.viewImage(base64) });
            }
            else {
                showModalDialog('modalDialog', i18next.t("viewingDocument"), "",
                    [<div className="filter-block-header">
                        <ul className="filter-header-buttons one-icons">
                            <li>
                                <button type="button" className="btn no-bg-btn" onClick={() => currentObject.actionHandlerCallback(actionTypes.download, [id])}>
                                    <div>
                                        <Svg src="/img/icn-download.svg" />
                                    </div>
                                    <span>{i18next.t("download")}</span>
                                </button>
                            </li>
                        </ul>
                    </div>,
                    <PdfViewer src={base64} />]
                    , "feedPopup max-size with-header-btns");
            }
        }
    }
    async actionHandlerCallback(type, ids) {
        let currentObject = this;
        // eslint-disable-next-line default-case
        switch (type) {
            case actionTypes.remove:
                {
                    let closeDialog = function () {
                        hideModalDialog('modalDialog');
                    }
                    let confirmDialog = function () {
                        currentObject.deleteAttachments(ids);
                        closeDialog();
                    }
                    showModalDialog('modalDialog', i18next.t("removing"), "", <div className="info-message">{i18next.t("deleteFilesMessage")}</div>, "feedPopup", true, [{ title: i18next.t("yes"), clickHandler: confirmDialog, class: "btn-primary" }, { title: i18next.t("no"), clickHandler: closeDialog, class: "btn-secondary" }]);
                    break;
                }
            case actionTypes.preview:
                this.loadFilePreview(ids[0]);
                break;
            case actionTypes.download:
                this.downloadFiles(ids);
                break;
            case actionTypes.change:
                {
                    let fileControl = document.getElementById("file-attachments-file-iput-controll");
                    fileControl.setAttribute('target-id', ids[0]);
                    fileControl.click();
                    break;
                }
        }
    }
    render() {
        const { actions, edite, name } = this.props;
        const { attachments, columns } = this.state;
        let rows = [];
        if (attachments) {
            for (let i = 0; i < attachments.length; ++i) {
                let currActions = [];
                if (attachments[i].fileName) {
                    currActions.push(...actions.filter(item => (attachments[i].fileName && item.type === actionTypes.download)
                        || (attachments[i].fileName && edite && item.type === actionTypes.remove)
                        || (attachments[i].fileName && edite && item.type === actionTypes.change)
                        || (attachments[i].fileName?.endsWith('.pdf') && item.type === actionTypes.preview)
                        || (CheckFunctions.isImageFile(attachments[i].fileName) && item.type === actionTypes.preview)));
                }
                let created = attachments[i]?.created ? new Date(attachments[i]?.created) : attachments[i]?.created;
                rows.push({
                    actions: currActions,
                    columns: {
                        Id: attachments[i]?.id,
                        NodeRef: attachments[i]?.nodeRef,
                        FileName: attachments[i]?.fileName,
                        CreatorFullName: attachments[i]?.creatorFullName,
                        Created: created ? `${created.toLocaleDateString("uk-UA")} ${created.toLocaleTimeString("uk-UA").substring(0, 5)}` : ""
                    }
                })
            }
        }
        return ([
            <Table key={name + "_attachments-table"} name={this.props.name} actionHandlerCallback={this.actionHandlerCallback} columns={columns} items={rows} sortBy="Title" isDesk={false} />,
            <input key={name + "_attachments-input"} id="file-attachments-file-iput-controll" onChange={this.changeFile} accept={this.props.acceptString} type="file" style={{ display: "none" }} />
        ]);
    }
}